import { Monitor, Video, Search, Users, Share2 } from 'lucide-react';
import Box from '../../components/Box';
import Text from '../../components/Text';
import classNames from 'classnames';

export default function AIMarketingTeam() {
  const teamMembers = [
    {
      icon: <Monitor className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "Instant Responsive Website Developer",
      description: "Builds a responsive school website in 2 minutes — with your logo, colours and mobile optimization.",
      impact: "Gives your school an instantly professional, parent-friendly presence.",
      highlight: true
    },
    {
      icon: <Video className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "Automated Reels and Video Generator",
      description: "Turns your photos & event clips into high quality professional short videos using your Brand Identity and Colors.",
      impact: "Everyday moments become shareable stories parents love.",
      highlight: true
    },
    {
      icon: <Search className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "SEO Specialist",
      description: "Writes smart, local keywords so parents nearby find your school on Google first.",
      impact: "Makes you visible to families actively seeking admissions."
    },
    {
      icon: <Users className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "24/7 Virtual Admissions Counsellor",
      description: "Answers queries, books appointments and follows up with interested parents.",
      impact: "Converts inquiries into confirmed admissions, never miss a lead again."
    },
    {
      icon: <Share2 className="w-6 h-6" />,
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      title: "Social Media Manager",
      description: "Shares daily posts — stories, festivals, achievements, parenting tips — automatically.",
      impact: "Keeps you visible 365 days a year; builds trust and connection."
    }
  ];

  return (
    <>
      <Box
        badge={"YOUR MARKETING TEAM"}
        title={"Meet Your AI-Marketing Team"}
        description={"Five specialised AI employees — customised to your school's brand — work silently, tirelessly, 24/7."}
        leftBlock={
          // <div className='col-span-3'>
          //   <div className="grid grid-cols-3 gap-6">

          //   </div>
          // </div>
          teamMembers.slice(0, 2).map((member, index) => <MarktingCard key={"memberUpperCard" + index} member={member} />)
        }
        rightBlock={<div className='col-span-2 md:col-span-1'>
          {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
          <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
            {teamMembers.slice(2).map((member, index) => <MarktingCard key={"memberInnerCard" + index} member={member} />)}
          </div>
        </div>}
      />

    </>
  );
}


export const MarktingCard = (data) => {
  const member = { ...data?.member };
  // return <div
  //   className={classNames(`bg-[white] rounded-2xl p-4 hover:shadow-lg transition-shadow duration-300 space-y-12 self-stretch border border-[#E2E8F1]`,member?.cName)}
  // >
  //   {/* Icon */}
  //  {!!member?.icon && <div className={`${member.iconBg} ${member.iconColor} w-12 h-12 rounded-lg flex items-center justify-center`}>
  //     {member.icon}
  //   </div>}

  //   <div className={'space-y-4'}>
  //     {/* Title */}
  //     <Text type='cardTitle' label={member.title} cName={"text-xl font-bold text-gray-900"} />

  //     {/* Description */}
  //     <Text type='description' label={member.description} cName={"mx-auto max-w-7xl text-xs text-[#4D4D4D] text-pretty font-medium"} />

  //     {/* Impact */}
  //     {!!member.impact && <div>
  //       <p className="text-sm text-gray-700">
  //         <Text label={"Impact:"} cName='font-semibold text-indigo-600' />{' '}
  //         <Text label={member.impact} cName='text-indigo-600' />
  //       </p>
  //     </div>}
  //     {!!member.footer && <div className={classNames(member?.footerClass)}>
  //       {(typeof(member.footer) === "string") ? <p className="text-sm text-[#999999]">
  //         <Text label={member.footer} />
  //       </p> : member.footer}
  //     </div>}
  //   </div>
  // </div>
  return <div
    className={classNames(
      `bg-[white] rounded-2xl p-4 hover:shadow-lg transition-shadow duration-300 
     space-y-12 self-stretch border border-[#E2E8F1] flex flex-col`,
      member?.cName
    )}
  >
    {/* Icon */}
    {!!member?.icon && (
      <div
        className={classNames(`${member.iconBg} ${member.iconColor} w-12 h-12 rounded-lg flex items-center justify-center`)}
      >
        {member.icon}
      </div>
    )}

    <div className="space-y-4 flex-1">
      {/* Custom Icon */}
      {!!member?.cIcon && (
        <div
          className={classNames(member?.cIconColor)}
        >
          {member.cIcon}
        </div>
      )}
      <div>
        {/* Tiny Title */}
        {!!member.tinyTitle && <Text
          type="description"
          label={member.tinyTitle}
          cName={"text-xs text-[#4D4D4D]"}
        />}

        {/* Title */}
        <Text
          type="cardTitle"
          label={member.title}
          cName={classNames("text-xl font-bold text-gray-900",member?.cName)}
        />
      </div>

      {/* Description */}
      {typeof (member.description) === "string" ? <Text
        type="description"
        label={member.description}
        cName={"text-xs text-[#4D4D4D] text-pretty font-medium"}
      /> : member.description}

      {/* Impact */}
      {!!member.impact && (
        <div>
          <p className="text-sm text-gray-700">
            <Text label={"Impact:"} cName="font-semibold text-indigo-600" />{" "}
            <Text label={member.impact} cName="text-indigo-600" />
          </p>
        </div>
      )}
    </div>

    {/* Footer */}
    {!!member.footer && (
      <div className={classNames(member.footerClass)}>
        {typeof member.footer === "string" ? (
          <p className="text-sm text-[#999999]">
            <Text label={member.footer} />
          </p>
        ) : (
          member.footer
        )}
      </div>
    )}
  </div>

}